<template>
  <el-form ref="form" :model="innerForm" label-width="200px" :rules="rules">
    <el-form-item label="账号" v-if="duplicationState">
      <el-select v-model="formData.ad_account_id" @change="onAccountChange" placeholder="请选择账号" style="width: 480px" filterable>
        <el-option v-for="item in accountData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="推广单元名称" prop="plan_name">
      <InputLen
        ref="planinput"
        v-model="innerForm.plan_name"
        placeholder="最大80个字符，1个中文等于2个字符"
        width="480"
        :max="80"
        :dyn-pos="dynpos"
      />
      <DynamicWord :words="dynamicWords" @append="appendWord" />
    </el-form-item>

    <el-form-item label="游戏平台">
      <el-radio-group v-model="innerForm.ch_platform_id" disabled @change="onPlatformChange">
        <el-radio-button ghost :label="1">Android</el-radio-button>
        <el-radio-button ghost :label="2">IOS</el-radio-button>
        <el-radio-button ghost :label="3">小程序</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="投放游戏">
      <el-select v-model="innerForm.game_id" filterable clearable disabled placeholder="请选择">
        <el-option v-for="g in platformGameData" value-key="id" :key="g.id" :label="g.name" :value="g.id"> </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="是否代投">
      <el-radio-group v-model="innerForm.agent" :disabled="editState">
        <el-radio-button ghost label="NOAGENT">非代投</el-radio-button>
        <el-radio-button ghost label="AGENT">代投</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="代投账号" v-if="innerForm.agent === 'AGENT'">
      <el-select v-model="innerForm.proxy_account_id" filterable placeholder="请选择">
        <el-option v-for="ag in agentData" value-key="id" :key="ag.id" :label="ag.name" :value="ag.id"> </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="投放方式">
      <el-radio-group v-model="innerForm.landing_type" disabled>
        <el-radio-button ghost label="APP">APP应用</el-radio-button>
        <el-radio-button ghost label="LINK">落地页</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="落地页地址" v-if="innerForm.landing_type === 'LINK'">
      <el-input v-model="innerForm.page_addr" style="width: 480px" readonly placeholder="选择内部落地页"></el-input>&ensp;
      <el-button type="primary" @click="openLandpageModal">选择落地页</el-button>

      <Landpage v-model="landpageModal" :default-game-id="innerForm.game_id" @on-select="onLandPageConfirm"></Landpage>
    </el-form-item>

    <el-form-item label="计划管家">
      <SelectButler :data="innerForm.managePlan" @on-clear="onButlerClear" @on-select="onButlerChange"></SelectButler>
    </el-form-item>

    <el-form-item label="智能自动化">
      <SelectMonitor :data="innerForm.planAutoTasks" :media="45" :open-id="opId" @on-delete="onMonitorClear" @on-select="onMonitorChange" />
    </el-form-item>

    <el-form-item label="回调开关">
      <el-switch v-model="innerForm.callback_switch" :active-value="1" :inactive-value="0"> </el-switch>
    </el-form-item>

    <el-form-item label="回调类型" v-if="innerForm.callback_switch">
      <el-checkbox-group v-model="innerForm.callback_settings">
        <el-checkbox label="callbackTypeActive" disabled>激活</el-checkbox>
        <el-checkbox label="callbackTypeRegist">注册</el-checkbox>
        <el-checkbox label="callbackTypeRecharge">付费</el-checkbox>
        <el-checkbox label="callbackTypeMoney">订单金额</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
  </el-form>
</template>
<script>
import Cookies from 'js-cookie'

import { isArray } from '@/common/js/utils'
import InputLen from '@/components/input/input-len'
import DynamicWord from './components/dynamic-words'

import SelectButler from '@/components/select/select-butler.vue'
import SelectMonitor from '@/components/select/select-monitor.vue'
import Landpage from '@/components/landpage/landpage.vue'

import { getCaoHuaGames, getCaoHuaAgent, adAccount } from '@/api/common.model'
import { makeBasicRules } from './data/form-rules.js'

const opId = Cookies.get('ch_op_id')
export default {
  components: { InputLen, DynamicWord, SelectButler, SelectMonitor, Landpage },
  data() {
    return {
      rules: { ...makeBasicRules.call(this) },
      landpageModal: false,
      dynamicWords: ['日期', '时间', '定向包名', '创意组名', '账号简称'],
      gameData: [], // 投放游戏
      agentData: [], //  代投账号
      dynpos: [],
      accountData: [],
      planMonitorData: [] // 智能自动化数据
    }
  },
  computed: {
    opId() {
      return opId
    },
    editState() {
      return this.$route.path.includes('/edit/')
    },
    duplicationState() {
      return this.$route.path.includes('/duplicate/')
    },
    platformGameData() {
      return this.gameData.filter((g) => g.ch_platform_id === this.innerForm.ch_platform_id)
    },

    formData: {
      get() {
        return this.$store.getters['Baidu/currTaskParams']
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_CURR_TASK', form)
      }
    },
    innerForm: {
      get() {
        return this.formData.innerForm
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_INNER_PARAMS', form)
      }
    }
  },
  methods: {
    /**
     * @description: 切换账号时，清除广告计划
     * @param {*} val
     */
    onAccountChange(val) {
      const account = this.accountData.find((ac) => ac.id === val)
      if (!account || !account.id) return this.$Message.warning('切换账号出错')

      const targetingForm = this.formData.targetingForm
      const newTargetingParam = targetingForm.targetingParam

      // 设置人群包为不限
      newTargetingParam.audienceMode = 'NONE'

      this.formData = {
        ...this.formData,
        ad_account_name: account.name,
        ad_account_id: account.id,
        targetingForm: {
          ...targetingForm,
          targetingParam: newTargetingParam
        },
        convert_params: {}
      }
    },
    /**
     * @description: 切换游戏平台
     */
    onPlatformChange() {
      const newForm = this.innerForm
      newForm.game_id = ''
      this.innerForm = newForm
    },
    /**
     * @description: 选择落地页
     */
    onLandPageConfirm(page) {
      const newForm = this.innerForm
      newForm.page_addr = page.page_addr
      newForm.land_page_id = page.land_page_id
      this.innerForm = newForm

      this.landpageModal = false
    },
    openLandpageModal() {
      this.landpageModal = true
    },
    /**
     * @description: 选择的管家结果
     */
    onButlerChange(items) {
      const [row] = items
      const newForm = this.innerForm
      newForm.managePlan = items
      this.innerForm = newForm
    },
    onButlerClear() {
      const newForm = this.innerForm
      newForm.managePlan = []
      this.innerForm = newForm
    },

    /**
     * @description: 选择智能自动化
     * @param {*} word
     * @return {*}
     */
    onMonitorChange(items) {
      const newForm = this.innerForm
      newForm.planAutoTasks = items.map((row) => ({ id: row.id, name: row.name }))

      this.innerForm = newForm
    },
    onMonitorClear(id) {
      const newForm = this.innerForm
      newForm.planAutoTasks = this.innerForm.planAutoTasks.filter((row) => row.id !== id)
      this.innerForm = newForm
    },

    appendWord(word) {
      const title = this.innerForm.plan_name
      const input = this.$refs.planinput
      const { selectionStart } = input.$el.querySelector('input')
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      if (title.indexOf(word) > -1) {
        return this.$Message.error('不能使用重复的动态词')
      }
      this.innerForm.plan_name = `${prefix}{${word}}${suffix}`
      this.getWordPosition()
      input.focus()
    },
    getWordPosition() {
      let dynPos = []
      const title = this.innerForm.plan_name
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = title.match(regexp)
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynamicWords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = title.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.dynpos = dynPos
    },
    getInitData() {
      Promise.all([getCaoHuaGames(), getCaoHuaAgent(), adAccount({ mediaId: 45, authFlag: 1 })]).then((data) => {
        const [gameData, agentData, accountData] = data
        this.gameData = gameData
        this.agentData = agentData
        isArray(accountData) && (this.accountData = accountData)
      })
    },
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('basic'))
          }
        })
      })
    }
  },
  created() {
    this.getInitData()
  }
}
</script>
<style lang="scss" scoped></style>
